import { Box, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ImgBg from "../../assets/images/indexes/bg-material.svg";
import { getConstituentsFile } from "../../services/indexes";
import { downloadFileInBrowser } from "../../utils";
import { useState } from "react";

interface Props {
  type: string;
  url: string;
  background: string;
  fileIndex: number;
  fileName: string;
  indexId: string;
}

const Material: React.FC<Props> = ({
  type,
  url,
  background,
  fileIndex,
  fileName,
  indexId,
}) => {
  const [downloading, setDownloading] = useState<boolean>(false);

  const handleOpenPdf = () => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleDownloadConstituentsFile = async () => {
    try {
      if (fileIndex && !downloading) {
        setDownloading(true);
        const file = await getConstituentsFile(indexId);
        downloadFileInBrowser(file, fileName, false);
        setDownloading(false);
      }
    } catch (error) {
      setDownloading(false);
    }
  };

  const handleClick = () => {
    if (type === "constituents_list") {
      handleDownloadConstituentsFile();
    } else {
      handleOpenPdf();
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "7.5rem",
        padding: "1.25rem",
        background,
        color: "#fff",
        cursor: "pointer",
      }}
      onClick={handleClick}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: "-4rem",
          left: "calc(100% - 6rem)",
          right: "-6rem",
          backgroundImage: `url(${ImgBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
      ></Box>
      <Box
        sx={{
          fontSize: "0.75rem",
        }}
      >
        <span style={{ borderBottom: "1px solid #fff", paddingBottom: 6 }}>
          INDEX RESOURCES
        </span>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            fontSize: "1rem",
            lineHeight: 1.2,
            fontWeight: 600,
            textTransform: "capitalize",
          }}
        >
          {type.split("_").join(" ")}
        </Box>
        <Box>
          {downloading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <DownloadIcon />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Material;
